import { Field, Float, ID, InputType, Int, ObjectType } from 'type-graphql'
import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'
import { AnalyzeImageForDocumentCodeArgs } from './AnalyzeImageForDocumentCodeArgs'
import { MatchedDocument } from '../../document-asset/MatchedDocument'

@InputType()
export class AnalyzePhotosArgs extends ActionArgs {
  @Field(() => [AnalyzeImageForDocumentCodeArgs])
  images: AnalyzeImageForDocumentCodeArgs[]
}

/**
 * Result returned immediately when batch analysis is queued.
 * Subscribe to `imageAnalysisCompleted` to receive individual results.
 */
@ObjectType()
@InputType('AnalyzePhotosResultInput')
export class AnalyzePhotosResult {
  @Field(() => ID)
  batchId: string

  @Field(() => Int)
  totalQueued: number
}

/**
 * Result published via photoAnalysisCompleted subscription for each completed photo analysis.
 * Used by mobile app to receive real-time analysis results.
 */
@ObjectType()
@InputType('PhotoAnalysisCompletedResultInput')
export class PhotoAnalysisCompletedResult {
  @Field(() => ID)
  batchId: string

  @Field(() => ID)
  id: string

  @Field(() => [String])
  documentCodes: string[]

  @Field(() => Float)
  confidence: number

  @Field(() => [MatchedDocument])
  matchedDocuments: MatchedDocument[]

  @Field(() => Boolean)
  shouldAutoAttach: boolean

  @Field(() => Boolean, { description: 'True if backend already attached the photo to documents via repository' })
  autoAttached: boolean

  @Field(() => String, { nullable: true })
  errorMessage?: string
}

export interface IAnalyzePhotos extends IAction<AnalyzePhotosResult, AnalyzePhotosArgs> {}
